module.exports = __webpack_public_path__ + "account/assets/additional.53b7611e.svg";